import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetDisciplineInfo = (id: string, teamId: string) => {
    const [resp, setResp] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!id || !teamId) return

        try {
            setIsLoading(true);

            const disciplineRequest = API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetDiscipline')
                .get()
                .addQuery('id', id || '')
                .send()
                .then((r) => r ? r.json() : undefined);

            const modulesRequest = API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetModulesList')
                .get()
                .addQuery('lMSModuleDisciplines', id)
                .addQuery('teamId', teamId || '')
                .send()
                .then((r) => r ? r.json() : undefined);

            Promise.all([disciplineRequest, modulesRequest]).then((response) => {
                setIsLoading(false);
                setResp({
                    discipline: response[0],
                    modules: response[1]?.data || []
                });
            });
        } catch (e) {
            setIsLoading(false);
            setError(true);
        }

    }, [id])


    return {info: resp, isLoading, error};
}
import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetDisciplineInfo = (id: string, teamId: string) => {
    const [resp, setResp] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!id || !teamId) return

        try {
            setIsLoading(true);

            const disciplineRequest = API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetDiscipline')
                .get()
                .addQuery('id', id || '')
                .send()
                .then((r) => r ? r.json() : undefined);

            const modulesRequest = API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetModulesList')
                .get()
                .addQuery('lMSModuleDisciplines', id)
                .addQuery('teamId', teamId || '')
                .send()
                .then((r) => r ? r.json() : undefined);

            Promise.all([disciplineRequest, modulesRequest]).then((response) => {
                setIsLoading(false);
                setResp({
                    discipline: response[0],
                    modules: response[1]?.data || []
                });
            });
        } catch (e) {
            setIsLoading(false);
            setError(true);
        }

    }, [id])


    return {info: resp, isLoading, error};
}
